const $ = require('jquery')
const Vue = require('vue')

Vue.component('ui-global-search', {
    props: {
        text: {
            default: null
        },
        only: {
            type: Array,
            default: null
        },
        onSearch: {
            type: Function,
            default: null
        }
    },
    methods: {
        search () {
            if (this.onSearch) {
                this.onSearch(this.text)
            }
        }
    },
    computed: {
        onlySearch () {
            if (this.only && Array.isArray(this.only)) {
                return this.only.join(',')
            }

            return this.only
        }
    },
    data () {
        return {}
    },
    ready () {
        if (this.only === null) {
            $(this.$els.input).pipelineSearch()
        }
    },
    template: require('templates/components/ui-global-search.html')
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/global-search.js